var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98711 8.94845C1.40636 8.94845 0.935565 9.41925 0.935565 10C0.935565 10.5808 1.40636 11.0515 1.98711 11.0515L9.34795 11.0515L9.34795 18.4124C9.34795 18.9931 9.81874 19.4639 10.3995 19.4639C10.9802 19.4639 11.451 18.9931 11.451 18.4124L11.451 11.0515H18.8119C19.3926 11.0515 19.8634 10.5808 19.8634 10C19.8634 9.41925 19.3926 8.94845 18.8119 8.94845H11.451L11.451 1.58762C11.451 1.00687 10.9802 0.536072 10.3995 0.536072C9.81874 0.536071 9.34795 1.00687 9.34795 1.58762L9.34795 8.94845L1.98711 8.94845Z",
    fill: "#92C99A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.4d5bdb8d67ca5a7ea72eb123015d6d3f.svg";
export { ForwardRef as ReactComponent };